import React, { ReactNode } from 'react';
import { ChevronDownIcon } from '@radix-ui/react-icons';

import { DropdownMenu } from '../modals/dropdown-menu/DropdownMenu';

import styles from './split-button.module.scss';

type Item = {
  onSelect: (event: Event) => void;
  title: ReactNode;
  icon?: ReactNode;
  type?: 'danger' | 'warning';
  disabled?: boolean;
  tooltipText?: string;
};

type AddBlockButtonProps = {
  id?: string;
  text: string;
  items: Item[];
  onClick?: () => void;
  icon?: ReactNode;
};

export const SplitButton: React.FC<AddBlockButtonProps> = ({ id, text, icon, items }) => (
  <DropdownMenu
    items={items}
    trigger={
      <div className={styles['button-container']} id={id}>
        <button className={styles['button']}>
          {icon}
          {text}
        </button>

        <button className={styles['open-select-button']}>
          <ChevronDownIcon />
        </button>
      </div>
    }
  />
);
